module.exports = __webpack_public_path__ + "img/num5.4293edd9.svg";